export default __webpack_public_path__ + "static/UniversLTW04-73BlackExt-507c4dea6299c7300fbae5310f86fb49.woff2";